import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {
  BrowserRouter as Router,
  Route,Routes,Navigate
} from 'react-router-dom';
import Main from './components/Jury/main';
import  {Gallery}  from './components/Gallery/index';
const Redirect = () => {
  // Redirect "/" to "flipkartconnect.com" and "/register" to "flipkartconnect.com/register"
  return <Navigate to="/" />;
};
const RedirectRegister = () => {
  // Redirect "/" to "flipkartconnect.com" and "/register" to "flipkartconnect.com/register"
  return <Navigate to="/register" />;
};

ReactDOM.render(
  <React.StrictMode>
   <Router>
   <Routes>
          <Route path="/" element={<App />} />
          <Route path="/jury" element={<Main />} />
          <Route path="/gallery" element={<Gallery />} />
        </Routes>
  </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
